import { createGlobalStyle } from 'styled-components';
export const NavOverrideStyles = createGlobalStyle(() => {
  const navStyles = {
    'padding-inline': '0.5rem !important',
    // 8px at default zoom

    // Remove padding on mobile (1079px and below to avoid overlap at 1080px)
    ['@media (max-width: 67.4375rem)']: {
      'padding-inline': '0 !important'
    }
  };
  const loadingNavStyles = {
    maxWidth: '100% !important',
    paddingInline: 'max(0.5rem, calc((100% - 95.5rem) / 2)) !important'
  };
  return {
    // Apply styles to loaded navigation
    ['.hs-global-nav .global-nav-header .global-nav-content-section']: navStyles,
    // Apply styles to loading stencils
    ['.hs-global-nav-loading']: loadingNavStyles
  };
});